import { SharedStoreModel } from './models';

import Computed from './computed/sharedStore.computed';
import Actions from './actions/sharedStore.actions';

const SharedStore = SharedStoreModel.views(Computed).actions(Actions);

export default SharedStore;
